import axios from "axios";
import { getToken } from "../../../request";
import { notification } from "../../../components/Elements/appUtils";
import { getGuestFeedbackUrl, deleteGuestFeedbackUrl } from "../api"

export const guestFeedbackListFxn = async (valData) => {
    let config = {
        params: { ...valData },
        ...(await getToken()),
    };

    const { data } = await axios.get(getGuestFeedbackUrl(), config);
    return data;
};

export const deleteGuestFeedbackFxn = (_id) => {
    return async () => {
        try {
            let config = await getToken();
            const { data } = await axios.delete(deleteGuestFeedbackUrl(_id), config);

            if (data?.success) {
                notification("success", data.message || "Deleted successfully");
            } else {
                notification("error", data.message || "Delete failed");
            }

            return data;
        } catch (error) {
            notification("error", error?.response?.data?.message || "Something went wrong");
            return { success: false };
        }
    };
};
